import { ElectionFieldData, RegionFieldData } from '~/definitions/generalSettings';

export const ERROR_MESSAGE_TITLE = 'Følgende felfer er feil';
export const ERROR_MESSAGE_INFO = 'Klikk på teksten for å fjerne denne meldingen.';

export const COMPANY_LABEL = 'S-Lag';

export const ELECTION_FIELD_DATA: { [key: string]: ElectionFieldData } = {
    electionSLagDescription: {
        id: 'election-s-lag-description',
        key: 'electionSLagDescription',
        name: 'election_s_lag_description',
        label: 'Om S-Laget',
    },
    electionHowToVoteDescription: {
        id: 'election-how-to-vote-description',
        key: 'electionHowToVoteDescription',
        name: 'election_how_to_vote_description',
        label: 'Slik stemmer du tekst (papirseddel)',
    },
};

export const ELECTION_FIELD_CONFIG: { [key: string]: string } = {
    electionSLagDescription: 'electionSLagDescription',
    electionHowToVoteDescription: 'electionHowToVoteDescription',
};

export const electionFieldConfigKeys = Object.keys(ELECTION_FIELD_DATA);

export const REGION_ATTRIBUTE_NUMBERS = {
    region_extra_vote_label: 'region_extra_vote_label',
    region_description: 'region_description',
    region_extra_vote_quantity: 'region_extra_vote_quantity',
    region_no_vote_description: 'region_no_vote_description',
};

export const regionAttributeNumberKeys = Object.values(REGION_ATTRIBUTE_NUMBERS);

export const REGION_FIELD_DATA: { [key: string]: RegionFieldData } = {
    regionName: {
        id: 'region-name',
        key: 'regionName',
        name: 'name',
        label: 'Regionnavn',
    },
    regionExtraVoteLabel: {
        id: 'region-extra-vote-label',
        key: 'regionExtraVoteLabel',
        name: 'region_extra_vote_label',
        label: 'Ekstrastemme / kumuler',
    },
    regionDescription: {
        id: 'region-description',
        key: 'regionDescription',
        name: 'region_description',
        label: 'Om region',
    },
    regionExtraVoteQuantity: {
        id: 'region-extra-vote-quantity',
        key: 'regionExtraVoteQuantity',
        name: 'region_extra_vote_quantity',
        label: 'Ant. kumuleringer som medlemmer kan gjøre',
    },
    regionNoVoteDescription: {
        id: 'region-no-vote-description',
        key: 'regionNoVoteDescription',
        name: 'region_no_vote_description',
        label: 'Kandidater som ikke er påvalg – til plakater',
    },
};

export const REGION_FIELD_CONFIG: { [key: string]: string } = {
    regionName: 'regionName',
    regionExtraVoteLabel: 'regionExtraVoteLabel',
    regionDescription: 'regionDescription',
    regionExtraVoteQuantity: 'regionExtraVoteQuantity',
    regionNoVoteDescription: 'regionNoVoteDescription',
};

export const regionFieldConfigKeys = Object.keys(REGION_FIELD_DATA);
